import { cn } from "@/common/utils/css.utils";
import { PropsWithChildren } from "react";
import { Helper } from "../../typography/Helper";
import { ElementProps } from "@/common/contracts/input.contracts";

export type InputGroupHelperProps = {
  className?: string;
} & PropsWithChildren<ElementProps>;

/**
 * Input group helper that should be used to render helper text bellow input element.
 *
 * @param valid Whether the helper text should be rendered with valid or invalid styling.
 * @param className List of CSS classes to pass to the helper.
 * @param props Rest of the helper props.
 */
export const InputGroupHelper = ({
  valid,
  className,
  ...props
}: InputGroupHelperProps) => {
  return (
    <Helper
      {...props}
      className={cn(valid === false && "text-attention-500", className)}
    />
  );
};
